function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M69.3468 45.2757C46.6035 50.5788 19.7228 68.0698 2 90.6045H249.475C249.475 90.6045 243.353 80.1913 230.141 70.0577C210.807 55.2281 186.624 47.451 167.95 43.6705C135.405 37.0816 100.926 37.9123 69.3468 45.2757Z",
  fill: "#D2D2D2",
  stroke: "#D2D2D2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M352.64 52.3545C353.431 58.5553 360.358 59.8041 364.389 60.2626C364.883 60.2626 366.511 60.0563 369.066 59.2311C373.173 57.9049 373.857 53.1567 373.857 51.5522C373.857 47.4263 371.119 46.2802 371.462 42.2689C371.579 40.8935 372.032 39.4036 371.462 36.0799C371.201 34.5605 369.18 31.4956 365.188 30.9225C359.598 30.1202 354.578 32.7563 355.605 39.5182C356.606 46.1051 352.069 47.8847 352.64 52.3545Z",
  fill: "#D2D2D2",
  stroke: "#D2D2D2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M364.388 38.602V68.4004H363.704L363.512 38.6276L364.05 36.1934L364.388 38.602Z",
  fill: "white",
  stroke: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M364.504 43.6438C365.074 43.491 366.375 43.0479 367.014 42.4977C367.652 41.9476 368.344 41.2752 368.611 41.0078",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M366.556 42.7277C366.48 42.3457 366.373 41.5129 366.556 41.2378C366.738 40.9627 366.936 40.5884 367.012 40.4355",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M363.249 39.4041C362.793 39.2513 361.766 38.8769 361.31 38.6019C360.854 38.3268 360.055 37.5704 359.713 37.2266",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M361.767 38.8304C361.767 38.4484 361.722 37.6385 361.539 37.4551",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M364.504 52.9273C365.455 53.0419 367.47 53.2023 367.926 52.9273C368.382 52.6522 368.953 52.2778 369.181 52.125",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M366.783 52.9275C366.935 52.4691 367.285 51.5293 367.468 51.4376C367.65 51.3459 368.076 51.1702 368.266 51.0938",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M363.247 48.229C362.487 48.1526 360.829 47.9539 360.281 47.7706C359.734 47.5872 358.38 46.6245 357.771 46.166",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M360.054 47.5407C360.016 47.1587 359.871 46.3258 359.598 46.0508",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M361.65 48.1133C361.384 48.4189 360.738 48.9614 360.281 49.1448",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M363.478 55.5642C362.641 55.526 360.808 55.4038 359.713 55.2204C358.618 55.037 357.356 54.1507 356.861 53.7305",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M361.195 55.3343C361.195 54.9905 361.081 54.3257 360.625 53.959",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M356.404 55.2188C356.48 55.2188 356.792 55.2188 357.431 55.2188C358.07 55.2188 358.306 54.9896 358.344 54.875",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M169.239 40.7444C146.496 46.0476 119.615 63.5385 101.893 86.0732H349.368C349.368 86.0732 343.245 75.6601 330.034 65.5265C310.7 50.6968 286.517 42.9198 267.843 39.1392C235.297 32.5503 200.818 33.381 169.239 40.7444Z",
  fill: "#D2D2D2",
  stroke: "#D2D2D2"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M313.221 22.0605C307.441 22.0605 307.441 27.6035 307.441 27.6035H319.264C319.264 27.6035 319.264 22.0605 313.221 22.0605Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M307.441 27.6035L303.5 57.6942H322.942L319.263 27.6035H307.441Z",
  fill: "white",
  stroke: "#C45513"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M305.602 57.957V61.1245H320.577V57.957H305.602Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 311.781,
  y: 36.5332,
  width: 2.78403,
  height: 4.32241,
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 311.357,
  y: 46.0527,
  width: 3.72906,
  height: 4.27907,
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M327.918 39.4166L324.628 41.8262L316.215 30.3205L319.397 27.8176L327.918 39.4166Z",
  fill: "white"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M302.854 12.0469L316.215 30.3205M316.215 30.3205L324.628 41.8262L327.918 39.4166L319.397 27.8176L316.215 30.3205Z",
  stroke: "#C45513"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M317.223 29.7346L325.628 40.9723L326.349 40.7368L317.828 29.1377L318.432 28.5408L326.954 40.1399",
  stroke: "#C45513",
  strokeWidth: 0.5
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M316.853 31.0548L320.108 28.7936L320.701 29.3986L317.447 31.6599L318.157 32.6263L321.051 30.4828L321.761 31.4492L318.867 33.5927L319.577 34.5592L322.471 32.4156L323.18 33.382L320.286 35.5256L320.996 36.492L323.89 34.3485L324.6 35.3149L321.706 37.4584L322.416 38.4249L325.31 36.2813L326.02 37.2477L323.126 39.3913L323.836 40.3577L327.09 38.0965",
  stroke: "#C45513",
  strokeWidth: 0.5
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M325.994 12.4857L328.385 15.7775L316.912 24.2345L314.427 21.0516L325.994 12.4857Z",
  fill: "white"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M298.689 37.666L316.912 24.2345M316.912 24.2345L328.385 15.7776L325.994 12.4857L314.427 21.0516L316.912 24.2345Z",
  stroke: "#C45513"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M316.314 23.2277L327.52 14.7795L327.287 14.0575L315.721 22.6232L315.128 22.0188L326.695 13.4531",
  stroke: "#C45513",
  strokeWidth: 0.5
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M317.627 23.5983L315.383 20.3397L315.986 19.7433L318.231 23.0019L319.195 22.2878L317.067 19.3904L318.031 18.6764L320.159 21.5738L321.123 20.8597L318.995 17.9623L319.959 17.2483L322.087 20.1457L323.051 19.4316L320.923 16.5342L321.887 15.8202L324.015 18.7176L324.979 18.0035L322.851 15.1061L323.815 14.3921L325.943 17.2895L326.908 16.5754L324.663 13.3169",
  stroke: "#C45513",
  strokeWidth: 0.5
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M299.916 14.3392L303.206 11.9297L311.619 23.4353L308.437 25.9382L299.916 14.3392Z",
  fill: "white"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M324.98 41.709L311.619 23.4353M311.619 23.4353L303.206 11.9297L299.916 14.3392L308.437 25.9382L311.619 23.4353Z",
  stroke: "#C45513"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M310.611 24.0213L302.206 12.7836L301.485 13.0191L310.006 24.6182L309.402 25.2151L300.88 13.616",
  stroke: "#C45513",
  strokeWidth: 0.5
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M310.98 22.7014L307.802 25.2006L307.132 24.3577L310.387 22.0964L309.677 21.1299L306.783 23.2735L306.073 22.3071L308.967 20.1635L308.257 19.1971L305.363 21.3406L304.653 20.3742L307.547 18.2306L306.837 17.2642L303.943 19.4078L303.233 18.4413L306.127 16.2978L305.417 15.3313L302.523 17.4749L301.813 16.5085L304.707 14.3649L303.997 13.3985L300.743 15.6597",
  stroke: "#C45513",
  strokeWidth: 0.5
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M300.971 40.6159L298.58 37.324L310.053 28.8671L312.538 32.05L300.971 40.6159Z",
  fill: "white"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M328.275 15.4355L310.053 28.8671M310.053 28.8671L298.58 37.324L300.971 40.6159L312.538 32.05L310.053 28.8671Z",
  stroke: "#C45513"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M310.651 29.8739L299.445 38.322L299.677 39.0441L311.244 30.4783L311.837 31.0828L300.27 39.6485",
  stroke: "#C45513",
  strokeWidth: 0.5
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M309.339 29.5045L311.821 32.6856L310.98 33.3594L308.735 30.1009L307.771 30.815L309.899 33.7123L308.935 34.4263L306.807 31.529L305.843 32.243L307.971 35.1404L307.007 35.8544L304.879 32.9571L303.915 33.6711L306.043 36.5684L305.079 37.2825L302.951 34.3852L301.987 35.0992L304.115 37.9965L303.151 38.7105L301.023 35.8132L300.059 36.5273L302.303 39.7857",
  stroke: "#C45513",
  strokeWidth: 0.5
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M257.53 65.9944C234.787 71.2976 208.229 90.7765 208.229 90.7765L419.936 89.7041C405.113 79.0206 374.807 68.1698 356.134 64.3892C323.588 57.8003 289.109 58.631 257.53 65.9944Z",
  fill: "#D2D2D2",
  stroke: "#D2D2D2"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M534.007 46.5706C511.264 51.8738 485.994 67.4938 468.271 90.0285H714.458C714.458 90.0285 708.013 81.4862 694.802 71.3526C675.468 56.523 651.284 48.746 632.611 44.9654C600.065 38.3765 565.586 39.2072 534.007 46.5706Z",
  fill: "#D2D2D2",
  stroke: "#D2D2D2"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M566.962 30.3533C548.542 35.6304 526.772 53.0355 512.418 75.4597H712.847C712.847 75.4597 707.889 65.0976 697.189 55.0137C681.53 40.2568 661.944 32.518 646.82 28.756C620.462 22.1994 592.537 23.026 566.962 30.3533Z",
  fill: "#D2D2D2",
  stroke: "#D2D2D2"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M362.579 55.9508C344.159 61.228 322.797 67.9283 308.443 90.3524H494.372C494.372 90.3524 496.503 92.2925 485.803 82.2086C470.144 67.4517 450.558 59.7129 435.434 55.9509C415.747 51.0537 388.154 48.6235 362.579 55.9508Z",
  fill: "#D2D2D2",
  stroke: "#D2D2D2"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M735.218 11.2408C706.552 17.9208 662.256 48.5893 639.699 90.9994L959.999 90.9994C959.999 90.9994 952.789 70.2833 920.687 45.6756C896.318 26.996 869.129 11.2408 836.262 5.53182C795.029 -1.63009 775.02 1.96579 735.218 11.2408Z",
  fill: "#D2D2D2",
  stroke: "#D2D2D2"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M691.417 32.119C657.303 40.0681 625.037 56.25 598.453 90.0281H958.71C958.71 90.0281 952.427 84.4553 932.609 69.2657C903.608 47.037 867.333 35.3797 839.323 29.7129C790.504 19.8366 738.786 21.0817 691.417 32.119Z",
  fill: "#D2D2D2",
  stroke: "#D2D2D2"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M406.233 61.8035C393.558 65.1434 378.578 76.1593 368.701 90.3518H506.617C506.617 90.3518 503.205 83.7936 495.842 77.4114C485.068 68.0716 471.591 63.1735 461.184 60.7925C443.046 56.6428 427.992 56.0696 406.233 61.8035Z",
  fill: "#D2D2D2",
  stroke: "#D2D2D2"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M830.213 42.273C831.371 51.3452 841.506 53.1723 847.403 53.843C848.127 53.843 850.508 53.5412 854.246 52.3339C860.255 50.3936 861.256 43.4467 861.256 41.0992C861.256 35.0627 857.251 33.3859 857.751 27.5171C857.923 25.5049 858.586 23.3251 857.751 18.4624C857.37 16.2392 854.413 11.7552 848.572 10.9167C840.394 9.74294 833.05 13.5996 834.552 23.4927C836.016 33.1298 829.379 35.7334 830.213 42.273Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M847.403 22.1509V65.7478H846.402L846.121 22.1884L846.909 18.627L847.403 22.1509Z",
  fill: "white",
  stroke: "white"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M847.57 29.5285C848.405 29.305 850.307 28.6566 851.242 27.8517C852.177 27.0469 853.189 26.0631 853.579 25.6719",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M850.575 28.1876C850.464 27.6287 850.308 26.4102 850.575 26.0077C850.842 25.6053 851.131 25.0576 851.243 24.834",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M845.737 23.3266C845.069 23.103 843.567 22.5552 842.899 22.1528C842.232 21.7504 841.063 20.6437 840.562 20.1406",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M843.566 22.4868C843.566 21.9278 843.499 20.7429 843.232 20.4746",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M847.57 43.1113C848.961 43.2789 851.91 43.5137 852.577 43.1113C853.245 42.7088 854.079 42.1611 854.413 41.9375",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M850.906 43.1106C851.129 42.4399 851.641 41.0649 851.908 40.9308C852.175 40.7966 852.798 40.5395 853.076 40.4277",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M845.732 36.237C844.619 36.1252 842.194 35.8346 841.393 35.5663C840.591 35.298 838.611 33.8895 837.721 33.2188",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M841.062 35.2306C841.006 34.6717 840.795 33.4532 840.395 33.0508",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M843.397 36.0684C843.008 36.5155 842.062 37.3092 841.395 37.5775",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M846.071 46.968C844.847 46.9122 842.165 46.7333 840.563 46.465C838.961 46.1967 837.114 44.9 836.391 44.2852",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M842.731 46.6333C842.731 46.1302 842.564 45.1577 841.896 44.6211",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M835.721 46.464C835.832 46.464 836.288 46.464 837.223 46.464C838.157 46.464 838.502 46.1286 838.558 45.9609",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M774.788 61.0484C775.945 70.1206 786.08 71.9477 791.978 72.6184C792.701 72.6184 795.082 72.3165 798.821 71.1092C804.829 69.1689 805.83 62.2221 805.83 59.8746C805.83 53.8381 801.825 52.1613 802.325 46.2925C802.497 44.2803 803.16 42.1005 802.325 37.2377C801.944 35.0146 798.987 30.5306 793.146 29.6921C784.968 28.5183 777.624 32.375 779.126 42.2681C780.59 51.9051 773.953 54.5088 774.788 61.0484Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M791.977 40.9263V84.5232H790.976L790.695 40.9638L791.483 37.4023L791.977 40.9263Z",
  fill: "white",
  stroke: "white"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M792.145 48.3039C792.979 48.0803 794.882 47.432 795.816 46.6271C796.751 45.8222 797.763 44.8385 798.153 44.4473",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M795.149 46.963C795.038 46.404 794.882 45.1856 795.149 44.7831C795.416 44.3807 795.706 43.8329 795.817 43.6094",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M790.311 42.1019C789.643 41.8784 788.141 41.3306 787.473 40.9282C786.806 40.5257 785.637 39.4191 785.137 38.916",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M788.14 41.2622C788.14 40.7032 788.074 39.5183 787.807 39.25",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M792.145 61.8867C793.535 62.0543 796.484 62.2891 797.152 61.8867C797.819 61.4842 798.654 60.9365 798.987 60.7129",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M795.48 61.886C795.703 61.2153 796.215 59.8403 796.482 59.7062C796.749 59.572 797.372 59.3149 797.65 59.2031",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M790.306 55.0124C789.193 54.9006 786.768 54.61 785.967 54.3417C785.166 54.0734 783.185 52.6649 782.295 51.9941",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M785.636 54.006C785.581 53.4471 785.369 52.2286 784.969 51.8262",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M787.972 54.8438C787.582 55.2909 786.636 56.0846 785.969 56.3529",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M790.645 65.7434C789.421 65.6875 786.74 65.5087 785.137 65.2404C783.535 64.9721 781.688 63.6754 780.965 63.0605",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M787.305 65.4086C787.305 64.9056 787.138 63.9331 786.471 63.3965",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M780.295 65.2394C780.406 65.2394 780.862 65.2394 781.797 65.2394C782.732 65.2394 783.077 64.904 783.132 64.7363",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M683.257 25.1342C684.142 32.0717 691.892 33.4689 696.402 33.9818C696.955 33.9818 698.776 33.751 701.635 32.8278C706.23 31.344 706.995 26.0317 706.995 24.2366C706.995 19.6204 703.932 18.3382 704.315 13.8503C704.446 12.3115 704.953 10.6446 704.315 6.92605C704.023 5.22603 701.763 1.79703 697.296 1.15588C691.042 0.258277 685.426 3.20749 686.575 10.7728C687.694 18.1423 682.619 20.1333 683.257 25.1342Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M696.402 9.74752V43.0863H695.636L695.422 9.77622L696.024 7.05273L696.402 9.74752Z",
  fill: "white",
  stroke: "white"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M696.529 15.3887C697.167 15.2177 698.622 14.7219 699.337 14.1064C700.052 13.4909 700.826 12.7386 701.124 12.4395",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M698.828 14.3633C698.743 13.9359 698.623 13.0042 698.828 12.6964C699.032 12.3887 699.253 11.9698 699.338 11.7988",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M695.126 10.6453C694.616 10.4743 693.467 10.0554 692.957 9.7477C692.446 9.43996 691.553 8.59366 691.17 8.20898",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M693.468 10.0036C693.468 9.57614 693.417 8.67001 693.213 8.46484",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M696.529 25.7745C697.593 25.9028 699.848 26.0823 700.358 25.7745C700.869 25.4668 701.507 25.0479 701.762 24.877",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M699.082 25.7743C699.252 25.2614 699.644 24.2099 699.848 24.1073C700.052 24.0048 700.528 23.8081 700.741 23.7227",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M695.124 20.519C694.273 20.4335 692.418 20.2113 691.806 20.0061C691.193 19.8009 689.679 18.7238 688.998 18.2109",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M691.554 19.749C691.511 19.3215 691.349 18.3898 691.043 18.082",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M693.338 20.3887C693.04 20.7306 692.317 21.3375 691.807 21.5427",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M695.383 28.7254C694.447 28.6827 692.396 28.5459 691.171 28.3408C689.946 28.1356 688.534 27.144 687.98 26.6738",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M692.83 28.4684C692.83 28.0837 692.702 27.34 692.191 26.9297",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M687.469 28.3398C687.554 28.3398 687.903 28.3398 688.617 28.3398C689.332 28.3398 689.596 28.0833 689.638 27.9551",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M520.853 53.4414C521.779 60.6992 529.887 62.1608 534.605 62.6974C535.184 62.6974 537.089 62.4559 540.079 61.4901C544.886 59.9379 545.687 54.3804 545.687 52.5024C545.687 47.6732 542.483 46.3318 542.883 41.6367C543.021 40.027 543.551 38.2831 542.883 34.3929C542.578 32.6144 540.213 29.0272 535.54 28.3564C528.997 27.4174 523.122 30.5027 524.324 38.4172C525.495 46.1268 520.186 48.2097 520.853 53.4414Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M534.604 37.3446V72.2221H533.803L533.578 37.3746L534.208 34.5254L534.604 37.3446Z",
  fill: "white",
  stroke: "white"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M534.738 43.2474C535.406 43.0686 536.928 42.5499 537.676 41.906C538.423 41.2621 539.233 40.4751 539.545 40.1621",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M537.143 42.1731C537.054 41.726 536.93 40.7512 537.143 40.4292C537.357 40.1073 537.588 39.6691 537.677 39.4902",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M533.272 38.2831C532.738 38.1043 531.536 37.6661 531.002 37.3441C530.468 37.0222 529.533 36.1368 529.133 35.7344",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M531.535 37.6117C531.535 37.1645 531.481 36.2166 531.268 36.002",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M534.738 54.1128C535.851 54.247 538.21 54.4348 538.744 54.1128C539.278 53.7909 539.946 53.3527 540.213 53.1738",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M537.408 54.1112C537.586 53.5746 537.996 52.4746 538.209 52.3673C538.423 52.26 538.921 52.0543 539.144 51.9648",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M533.268 48.6119C532.378 48.5224 530.438 48.2899 529.797 48.0753C529.156 47.8607 527.571 46.7338 526.859 46.1973",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M529.532 47.8064C529.488 47.3592 529.319 46.3844 528.998 46.0625",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M531.401 48.4785C531.089 48.8362 530.333 49.4712 529.799 49.6858",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M533.539 57.1971C532.56 57.1524 530.415 57.0093 529.133 56.7947C527.851 56.58 526.374 55.5426 525.795 55.0508",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M530.867 56.9301C530.867 56.5276 530.733 55.7496 530.199 55.3203",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M525.26 56.795C525.349 56.795 525.714 56.795 526.461 56.795C527.209 56.795 527.485 56.5267 527.53 56.3926",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M255.404 49.54C256.116 55.1177 262.347 56.241 265.973 56.6533C266.417 56.6533 267.881 56.4678 270.18 55.7255C273.874 54.5326 274.489 50.2617 274.489 48.8184C274.489 45.1071 272.027 44.0762 272.335 40.468C272.44 39.2309 272.848 37.8908 272.335 34.9011C272.1 33.5344 270.282 30.7775 266.691 30.262C261.663 29.5404 257.148 31.9115 258.072 37.9938C258.972 43.9187 254.891 45.5195 255.404 49.54Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M265.972 37.1685V63.9721H265.356L265.184 37.1916L265.668 35.002L265.972 37.1685Z",
  fill: "white",
  stroke: "white"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M266.076 41.7051C266.589 41.5676 267.759 41.169 268.334 40.6742C268.908 40.1793 269.531 39.5745 269.77 39.334",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M267.923 40.8802C267.854 40.5365 267.758 39.7874 267.923 39.54C268.087 39.2926 268.265 38.9558 268.333 38.8184",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M264.947 37.8904C264.536 37.7529 263.613 37.4162 263.202 37.1687C262.792 36.9213 262.073 36.2409 261.766 35.9316",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M263.613 37.3758C263.613 37.0321 263.572 36.3036 263.408 36.1387",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M266.076 50.0556C266.931 50.1587 268.744 50.303 269.155 50.0556C269.565 49.8082 270.078 49.4714 270.283 49.334",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M268.127 50.0557C268.264 49.6433 268.578 48.798 268.743 48.7155C268.907 48.6331 269.29 48.475 269.461 48.4062",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M264.945 45.8283C264.261 45.7596 262.77 45.5809 262.277 45.4159C261.784 45.251 260.567 44.385 260.02 43.9727",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M262.074 45.2093C262.04 44.8657 261.91 44.1166 261.664 43.8691",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M263.511 45.7246C263.271 45.9995 262.69 46.4875 262.279 46.6524",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M265.153 52.4268C264.4 52.3924 262.752 52.2825 261.766 52.1175C260.781 51.9526 259.646 51.1553 259.201 50.7773",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M263.101 52.2215C263.101 51.9122 262.998 51.3143 262.588 50.9844",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M258.791 52.1179C258.859 52.1179 259.14 52.1179 259.715 52.1179C260.289 52.1179 260.501 51.9117 260.535 51.8086",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M749.644 47.4082C750.634 55.1651 759.3 56.7272 764.342 57.3007C764.96 57.3007 766.996 57.0426 770.193 56.0104C775.33 54.3514 776.186 48.4118 776.186 46.4046C776.186 41.2433 772.761 39.8096 773.19 34.7917C773.336 33.0712 773.903 31.2074 773.19 27.0497C772.863 25.1489 770.336 21.315 765.341 20.5981C758.349 19.5945 752.069 22.892 753.354 31.3508C754.606 39.5906 748.931 41.8167 749.644 47.4082Z",
  fill: "#121212",
  stroke: "#121212"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M764.34 30.2044V67.4805H763.484L763.244 30.2365L763.918 27.1914L764.34 30.2044Z",
  fill: "white",
  stroke: "white"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M764.484 36.5123C765.198 36.3212 766.825 35.7668 767.624 35.0786C768.423 34.3905 769.289 33.5494 769.622 33.2148",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M767.054 35.3654C766.959 34.8875 766.825 33.8457 767.054 33.5016C767.282 33.1575 767.529 32.6892 767.625 32.498",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M762.916 31.2084C762.345 31.0172 761.061 30.5489 760.49 30.2048C759.919 29.8607 758.92 28.9145 758.492 28.4844",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M761.061 30.49C761.061 30.0121 761.004 28.9989 760.775 28.7695",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M764.484 48.1247C765.674 48.268 768.195 48.4688 768.765 48.1247C769.336 47.7806 770.05 47.3123 770.335 47.1211",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M767.338 48.124C767.528 47.5505 767.966 46.3749 768.194 46.2602C768.422 46.1455 768.955 45.9257 769.193 45.8301",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M762.914 42.2467C761.963 42.1511 759.889 41.9026 759.204 41.6732C758.519 41.4438 756.826 40.2395 756.064 39.666",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M758.921 41.3872C758.873 40.9093 758.692 39.8675 758.35 39.5234",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M760.917 42.1035C760.585 42.4858 759.776 43.1644 759.205 43.3938",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M763.202 51.4228C762.156 51.375 759.863 51.2221 758.493 50.9927C757.123 50.7633 755.544 49.6546 754.926 49.1289",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M760.348 51.1364C760.348 50.7063 760.206 49.8748 759.635 49.416",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M754.354 50.9926C754.449 50.9926 754.839 50.9926 755.638 50.9926C756.437 50.9926 756.732 50.7059 756.779 50.5625",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M651.041 37.6972C652.03 45.4541 660.696 47.0163 665.738 47.5898C666.357 47.5898 668.393 47.3317 671.589 46.2994C676.726 44.6405 677.583 38.7008 677.583 36.6937C677.583 31.5324 674.158 30.0987 674.586 25.0807C674.733 23.3603 675.299 21.4965 674.586 17.3388C674.26 15.438 671.732 11.604 666.737 10.8872C659.745 9.88357 653.466 13.1811 654.751 21.6399C656.002 29.8797 650.327 32.1058 651.041 37.6972Z",
  fill: "#121212",
  stroke: "#121212"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M665.737 20.4935V57.7696H664.881L664.641 20.5256L665.314 17.4805L665.737 20.4935Z",
  fill: "white",
  stroke: "white"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M665.881 26.8014C666.594 26.6102 668.221 26.0559 669.02 25.3677C669.819 24.6795 670.685 23.8384 671.018 23.5039",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M668.45 25.6545C668.355 25.1766 668.222 24.1348 668.45 23.7907C668.679 23.4466 668.926 22.9783 669.021 22.7871",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M664.312 21.4975C663.742 21.3063 662.457 20.838 661.887 20.4939C661.316 20.1498 660.317 19.2035 659.889 18.7734",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M662.457 20.779C662.457 20.3011 662.4 19.288 662.172 19.0586",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M665.881 38.4137C667.07 38.5571 669.591 38.7578 670.162 38.4137C670.733 38.0697 671.446 37.6013 671.732 37.4102",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M668.734 38.4131C668.925 37.8396 669.362 36.6639 669.591 36.5492C669.819 36.4346 670.352 36.2147 670.59 36.1191",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M664.311 32.5357C663.359 32.4401 661.285 32.1916 660.6 31.9622C659.915 31.7329 658.222 30.5286 657.461 29.9551",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M660.317 31.6763C660.269 31.1984 660.089 30.1566 659.746 29.8125",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M662.314 32.3926C661.981 32.7749 661.172 33.4535 660.602 33.6829",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M664.599 41.7119C663.553 41.6641 661.26 41.5112 659.89 41.2818C658.52 41.0524 656.941 39.9437 656.322 39.418",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M661.745 41.4255C661.745 40.9954 661.602 40.1639 661.031 39.7051",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M655.75 41.2817C655.845 41.2817 656.235 41.2817 657.034 41.2817C657.833 41.2817 658.128 40.9949 658.176 40.8516",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M500.226 59.8774C501.047 66.3189 508.244 67.6162 512.431 68.0924C512.944 68.0924 514.635 67.8781 517.29 67.0209C521.556 65.6432 522.267 60.7108 522.267 59.044C522.267 54.7579 519.423 53.5673 519.778 49.4003C519.9 47.9716 520.371 46.4238 519.778 42.9711C519.507 41.3926 517.408 38.2088 513.261 37.6135C507.454 36.7801 502.239 39.5184 503.306 46.5428C504.346 53.3854 499.633 55.2341 500.226 59.8774Z",
  fill: "#121212",
  stroke: "#121212"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M512.43 45.59V76.5452H511.719L511.52 45.6167L512.079 43.0879L512.43 45.59Z",
  fill: "white",
  stroke: "white"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M512.551 50.8282C513.143 50.6694 514.494 50.2091 515.158 49.6376C515.821 49.0661 516.54 48.3676 516.817 48.0898",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M514.683 49.8773C514.604 49.4804 514.493 48.6152 514.683 48.3295C514.872 48.0438 515.078 47.6548 515.157 47.4961",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M511.248 46.4242C510.774 46.2655 509.707 45.8765 509.233 45.5908C508.759 45.3051 507.93 44.5193 507.574 44.1621",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M509.706 45.8291C509.706 45.4322 509.658 44.5909 509.469 44.4004",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M512.551 60.4721C513.538 60.5911 515.632 60.7578 516.106 60.4721C516.58 60.1863 517.172 59.7974 517.409 59.6387",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M514.918 60.4733C515.076 59.9971 515.439 59.0208 515.629 58.9255C515.819 58.8303 516.261 58.6477 516.459 58.5684",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M511.245 55.5923C510.455 55.5129 508.733 55.3065 508.164 55.116C507.595 54.9255 506.189 53.9255 505.557 53.4492",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M507.929 54.8759C507.89 54.479 507.739 53.6139 507.455 53.3281",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M509.586 55.4727C509.31 55.7901 508.638 56.3537 508.164 56.5442",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M511.485 63.2116C510.616 63.1719 508.712 63.0449 507.574 62.8544C506.436 62.6639 505.125 61.7432 504.611 61.3066",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M509.114 62.9736C509.114 62.6164 508.995 61.9259 508.521 61.5449",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M504.137 62.8533C504.216 62.8533 504.54 62.8533 505.203 62.8533C505.867 62.8533 506.112 62.6152 506.151 62.4961",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M238.559 57.4712C239.191 62.4216 244.721 63.4186 247.939 63.7845C248.334 63.7845 249.633 63.6198 251.673 62.9611C254.952 61.9023 255.498 58.1117 255.498 56.8307C255.498 53.5368 253.312 52.6219 253.586 49.4195C253.679 48.3215 254.041 47.132 253.586 44.4786C253.377 43.2655 251.764 40.8187 248.577 40.3612C244.114 39.7207 240.107 41.8252 240.927 47.2235C241.726 52.4821 238.104 53.9028 238.559 57.4712Z",
  fill: "#121212",
  stroke: "#121212"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M247.938 46.4913V70.2805H247.391L247.238 46.5117L247.668 44.5684L247.938 46.4913Z",
  fill: "white",
  stroke: "white"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M248.031 50.5185C248.487 50.3965 249.525 50.0427 250.035 49.6035C250.545 49.1643 251.097 48.6276 251.31 48.4141",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M249.67 49.785C249.61 49.48 249.525 48.8152 249.67 48.5956C249.816 48.376 249.974 48.0771 250.035 47.9551",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M247.028 47.133C246.664 47.011 245.844 46.7121 245.48 46.4925C245.116 46.2729 244.478 45.669 244.205 45.3945",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  d: "M245.846 46.6741C245.846 46.3691 245.81 45.7226 245.664 45.5762",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  d: "M248.031 57.9295C248.79 58.021 250.399 58.1491 250.763 57.9295C251.128 57.71 251.583 57.4111 251.765 57.2891",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  d: "M249.85 57.9288C249.971 57.5628 250.25 56.8125 250.396 56.7393C250.542 56.6661 250.882 56.5258 251.034 56.4648",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M247.028 54.1782C246.42 54.1172 245.097 53.9586 244.66 53.8122C244.223 53.6658 243.142 52.8972 242.656 52.5312",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  d: "M244.48 53.6289C244.449 53.3239 244.334 52.659 244.115 52.4395",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  d: "M245.753 54.0859C245.54 54.3299 245.024 54.763 244.66 54.9094",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  d: "M247.212 60.0323C246.544 60.0018 245.081 59.9042 244.206 59.7578C243.332 59.6114 242.324 58.9038 241.93 58.5684",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  d: "M245.389 59.8499C245.389 59.5754 245.298 59.0447 244.934 58.752",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  d: "M241.564 59.7589C241.625 59.7589 241.874 59.7589 242.384 59.7589C242.894 59.7589 243.082 59.5759 243.113 59.4844",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  d: "M271.426 62.2505C272.058 67.2009 277.588 68.1979 280.806 68.5638C281.201 68.5638 282.5 68.3991 284.54 67.7404C287.819 66.6816 288.365 62.891 288.365 61.61C288.365 58.3161 286.18 57.4012 286.453 54.1987C286.547 53.1008 286.908 51.9113 286.453 49.2579C286.245 48.0448 284.631 45.598 281.444 45.1405C276.981 44.5 272.974 46.6045 273.794 52.0028C274.593 57.2614 270.971 58.6821 271.426 62.2505Z",
  fill: "#121212",
  stroke: "#121212"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  d: "M280.805 51.2706V75.0598H280.259L280.105 51.291L280.535 49.3477L280.805 51.2706Z",
  fill: "white",
  stroke: "white"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  d: "M280.898 55.2978C281.354 55.1758 282.392 54.822 282.902 54.3828C283.412 53.9436 283.964 53.4069 284.177 53.1934",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  d: "M282.537 54.5643C282.477 54.2593 282.392 53.5944 282.537 53.3749C282.683 53.1553 282.841 52.8564 282.902 52.7344",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  d: "M279.895 51.9123C279.531 51.7903 278.712 51.4914 278.347 51.2718C277.983 51.0522 277.345 50.4483 277.072 50.1738",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  d: "M278.713 51.4534C278.713 51.1484 278.677 50.5019 278.531 50.3555",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref178 = /*#__PURE__*/React.createElement("path", {
  d: "M280.898 62.7088C281.657 62.8003 283.266 62.9284 283.631 62.7088C283.995 62.4892 284.45 62.1904 284.632 62.0684",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref179 = /*#__PURE__*/React.createElement("path", {
  d: "M282.717 62.7081C282.838 62.3421 283.118 61.5918 283.263 61.5186C283.409 61.4454 283.749 61.3051 283.901 61.2441",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref180 = /*#__PURE__*/React.createElement("path", {
  d: "M279.895 58.9575C279.288 58.8965 277.964 58.7379 277.527 58.5915C277.09 58.4451 276.009 57.6765 275.523 57.3105",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref181 = /*#__PURE__*/React.createElement("path", {
  d: "M277.347 58.4082C277.316 58.1032 277.201 57.4383 276.982 57.2188",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref182 = /*#__PURE__*/React.createElement("path", {
  d: "M278.62 58.8652C278.408 59.1092 277.892 59.5423 277.527 59.6887",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref183 = /*#__PURE__*/React.createElement("path", {
  d: "M280.079 64.8116C279.411 64.7811 277.948 64.6835 277.074 64.5371C276.199 64.3907 275.192 63.6831 274.797 63.3477",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref184 = /*#__PURE__*/React.createElement("path", {
  d: "M278.256 64.6292C278.256 64.3547 278.165 63.824 277.801 63.5312",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref185 = /*#__PURE__*/React.createElement("path", {
  d: "M274.432 64.5382C274.492 64.5382 274.741 64.5382 275.251 64.5382C275.761 64.5382 275.95 64.3552 275.98 64.2637",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref186 = /*#__PURE__*/React.createElement("path", {
  d: "M453.183 50.7856C454.07 57.7381 461.837 59.1382 466.356 59.6522C466.91 59.6522 468.735 59.4209 471.6 58.4957C476.205 57.0088 476.972 51.6851 476.972 49.8861C476.972 45.26 473.903 43.975 474.286 39.4775C474.418 37.9354 474.926 36.2649 474.286 32.5384C473.994 30.8347 471.728 27.3984 467.252 26.7558C460.984 25.8563 455.356 28.8118 456.508 36.3934C457.63 43.7787 452.543 45.774 453.183 50.7856Z",
  fill: "#D2D2D2",
  stroke: "#D2D2D2"
});

var _ref187 = /*#__PURE__*/React.createElement("path", {
  d: "M466.356 35.3646V68.775H465.588L465.373 35.3934L465.977 32.6641L466.356 35.3646Z",
  fill: "white",
  stroke: "white"
});

var _ref188 = /*#__PURE__*/React.createElement("path", {
  d: "M466.484 41.02C467.124 40.8487 468.582 40.3518 469.298 39.735C470.015 39.1182 470.79 38.3643 471.089 38.0645",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref189 = /*#__PURE__*/React.createElement("path", {
  d: "M468.787 39.9919C468.702 39.5636 468.582 38.6298 468.787 38.3214C468.991 38.013 469.213 37.5932 469.298 37.4219",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref190 = /*#__PURE__*/React.createElement("path", {
  d: "M465.078 36.2657C464.567 36.0944 463.416 35.6746 462.904 35.3662C462.392 35.0578 461.497 34.2097 461.113 33.8242",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref191 = /*#__PURE__*/React.createElement("path", {
  d: "M463.416 35.6221C463.416 35.1938 463.365 34.2857 463.16 34.0801",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref192 = /*#__PURE__*/React.createElement("path", {
  d: "M466.484 51.4288C467.55 51.5573 469.81 51.7372 470.321 51.4288C470.833 51.1204 471.473 50.7006 471.728 50.5293",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref193 = /*#__PURE__*/React.createElement("path", {
  d: "M469.041 51.4271C469.212 50.9131 469.604 49.8594 469.808 49.7566C470.013 49.6538 470.491 49.4568 470.704 49.3711",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref194 = /*#__PURE__*/React.createElement("path", {
  d: "M465.077 46.1607C464.224 46.075 462.365 45.8523 461.751 45.6467C461.137 45.4411 459.62 44.3617 458.938 43.8477",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref195 = /*#__PURE__*/React.createElement("path", {
  d: "M461.496 45.3893C461.453 44.9609 461.291 44.0272 460.984 43.7188",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref196 = /*#__PURE__*/React.createElement("path", {
  d: "M463.287 46.0312C462.988 46.3739 462.264 46.9822 461.752 47.1878",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref197 = /*#__PURE__*/React.createElement("path", {
  d: "M465.334 54.3842C464.396 54.3413 462.341 54.2042 461.114 53.9986C459.886 53.793 458.47 52.7993 457.916 52.3281",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref198 = /*#__PURE__*/React.createElement("path", {
  d: "M462.776 54.126C462.776 53.7405 462.648 52.9952 462.137 52.584",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref199 = /*#__PURE__*/React.createElement("path", {
  d: "M457.402 53.9968C457.488 53.9968 457.837 53.9968 458.553 53.9968C459.27 53.9968 459.534 53.7398 459.577 53.6113",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref200 = /*#__PURE__*/React.createElement("path", {
  d: "M671.655 42.7978C672.499 49.4152 679.892 50.7479 684.193 51.2371C684.721 51.2371 686.458 51.017 689.185 50.1363C693.567 48.721 694.298 43.6539 694.298 41.9416C694.298 37.5385 691.376 36.3154 691.741 32.0346C691.866 30.5669 692.35 28.9769 691.741 25.4299C691.463 23.8084 689.306 20.5376 685.045 19.926C679.08 19.0698 673.723 21.883 674.819 29.0992C675.887 36.1286 671.046 38.0277 671.655 42.7978Z",
  fill: "white",
  stroke: "white"
});

var _ref201 = /*#__PURE__*/React.createElement("path", {
  d: "M684.193 28.1212V59.9215H683.463L683.258 28.1486L683.832 25.5508L684.193 28.1212Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref202 = /*#__PURE__*/React.createElement("path", {
  d: "M684.316 33.5026C684.925 33.3395 686.313 32.8666 686.995 32.2795C687.676 31.6924 688.415 30.9748 688.699 30.6895",
  stroke: "#C45513",
  strokeLinecap: "round"
});

var _ref203 = /*#__PURE__*/React.createElement("path", {
  d: "M686.506 32.5243C686.425 32.1166 686.311 31.2278 686.506 30.9343C686.701 30.6407 686.912 30.2412 686.993 30.0781",
  stroke: "#C45513",
  strokeLinecap: "round"
});

var _ref204 = /*#__PURE__*/React.createElement("path", {
  d: "M682.977 28.9762C682.49 28.8131 681.394 28.4136 680.907 28.12C680.42 27.8265 679.568 27.0193 679.203 26.6523",
  stroke: "#C45513",
  strokeLinecap: "round"
});

var _ref205 = /*#__PURE__*/React.createElement("path", {
  d: "M681.394 28.3642C681.394 27.9565 681.345 27.0922 681.15 26.8965",
  stroke: "#C45513",
  strokeLinecap: "round"
});

var _ref206 = /*#__PURE__*/React.createElement("path", {
  d: "M684.316 43.4089C685.331 43.5312 687.482 43.7024 687.969 43.4089C688.456 43.1154 689.064 42.7158 689.308 42.5527",
  stroke: "#C45513",
  strokeLinecap: "round"
});

var _ref207 = /*#__PURE__*/React.createElement("path", {
  d: "M686.748 43.4081C686.91 42.9189 687.284 41.9159 687.478 41.8181C687.673 41.7203 688.128 41.5327 688.331 41.4512",
  stroke: "#C45513",
  strokeLinecap: "round"
});

var _ref208 = /*#__PURE__*/React.createElement("path", {
  d: "M682.974 38.3949C682.163 38.3134 680.393 38.1014 679.809 37.9057C679.225 37.71 677.78 36.6826 677.131 36.1934",
  stroke: "#C45513",
  strokeLinecap: "round"
});

var _ref209 = /*#__PURE__*/React.createElement("path", {
  d: "M679.569 37.6603C679.528 37.2526 679.374 36.3639 679.082 36.0703",
  stroke: "#C45513",
  strokeLinecap: "round"
});

var _ref210 = /*#__PURE__*/React.createElement("path", {
  d: "M681.271 38.2715C680.987 38.5976 680.297 39.1766 679.811 39.3723",
  stroke: "#C45513",
  strokeLinecap: "round"
});

var _ref211 = /*#__PURE__*/React.createElement("path", {
  d: "M683.221 46.2226C682.328 46.1818 680.372 46.0513 679.204 45.8556C678.035 45.6599 676.688 44.7141 676.16 44.2656",
  stroke: "#C45513",
  strokeLinecap: "round"
});

var _ref212 = /*#__PURE__*/React.createElement("path", {
  d: "M680.786 45.9775C680.786 45.6105 680.665 44.9012 680.178 44.5098",
  stroke: "#C45513",
  strokeLinecap: "round"
});

var _ref213 = /*#__PURE__*/React.createElement("path", {
  d: "M675.672 45.8552C675.753 45.8552 676.086 45.8552 676.768 45.8552C677.449 45.8552 677.701 45.6106 677.742 45.4883",
  stroke: "#C45513",
  strokeLinecap: "round"
});

var _ref214 = /*#__PURE__*/React.createElement("path", {
  d: "M481.525 67.3588C482.201 72.6609 488.125 73.7286 491.571 74.1206C491.994 74.1206 493.386 73.9442 495.571 73.2387C499.082 72.1047 499.667 68.0447 499.667 66.6728C499.667 63.1449 497.326 62.1649 497.619 58.735C497.719 57.559 498.107 56.285 497.619 53.4431C497.396 52.1438 495.668 49.5232 492.254 49.0332C487.475 48.3472 483.183 50.6011 484.061 56.383C484.916 62.0152 481.037 63.5368 481.525 67.3588Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref215 = /*#__PURE__*/React.createElement("path", {
  d: "M491.572 55.5986V81.078H490.986L490.822 55.6205L491.283 53.5391L491.572 55.5986Z",
  fill: "white",
  stroke: "white"
});

var _ref216 = /*#__PURE__*/React.createElement("path", {
  d: "M491.67 59.9121C492.158 59.7815 493.27 59.4026 493.816 58.9322C494.362 58.4618 494.954 57.8869 495.181 57.6582",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref217 = /*#__PURE__*/React.createElement("path", {
  d: "M493.426 59.1279C493.361 58.8013 493.27 58.0891 493.426 57.854C493.582 57.6188 493.751 57.2986 493.816 57.168",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref218 = /*#__PURE__*/React.createElement("path", {
  d: "M490.598 56.2858C490.208 56.1551 489.33 55.835 488.94 55.5998C488.55 55.3646 487.867 54.7178 487.574 54.4238",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref219 = /*#__PURE__*/React.createElement("path", {
  d: "M489.328 55.7951C489.328 55.4685 489.289 54.7759 489.133 54.6191",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref220 = /*#__PURE__*/React.createElement("path", {
  d: "M491.67 67.85C492.483 67.948 494.206 68.0852 494.596 67.85C494.986 67.6149 495.474 67.2947 495.669 67.1641",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref221 = /*#__PURE__*/React.createElement("path", {
  d: "M493.619 67.8492C493.749 67.4572 494.048 66.6536 494.204 66.5752C494.36 66.4968 494.725 66.3466 494.887 66.2812",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref222 = /*#__PURE__*/React.createElement("path", {
  d: "M490.596 63.8304C489.946 63.765 488.528 63.5952 488.06 63.4384C487.592 63.2816 486.434 62.4584 485.914 62.0664",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref223 = /*#__PURE__*/React.createElement("path", {
  d: "M487.865 63.2427C487.832 62.9161 487.709 62.2039 487.475 61.9688",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref224 = /*#__PURE__*/React.createElement("path", {
  d: "M489.229 63.7324C489.001 63.9937 488.449 64.4576 488.059 64.6144",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref225 = /*#__PURE__*/React.createElement("path", {
  d: "M490.792 70.1031C490.077 70.0705 488.51 69.9659 487.573 69.8091C486.637 69.6523 485.557 68.8945 485.135 68.5352",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref226 = /*#__PURE__*/React.createElement("path", {
  d: "M488.841 69.9064C488.841 69.6124 488.744 69.0441 488.354 68.7305",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref227 = /*#__PURE__*/React.createElement("path", {
  d: "M596.025 50.2093C596.863 50.514 597.338 51.6421 598.259 52.647C598.818 53.2563 599.342 53.2563 600.493 53.2563H603.286V54.7798C602.232 55.0671 598.773 55.2856 597.841 54.6589L598.259 55.3892H596.025C595.589 53.2399 593.619 49.8856 594.908 50.2093H595.466L596.025 50.2093Z",
  fill: "white",
  stroke: "#C45513",
  strokeWidth: 0.5
});

var _ref228 = /*#__PURE__*/React.createElement("path", {
  d: "M595.876 48.9132C595.782 48.9132 595.983 49.9924 596.198 50.2082L594.756 50.1273C594.909 49.8844 595.04 49.3488 594.587 48.5895C593.62 46.9708 594.194 46.1607 594.408 45.9187C594.909 45.3521 595.554 45.352 596.198 45.6758C596.843 45.9995 597.165 46.3232 597.165 47.6183C597.165 49.5607 596.055 48.9132 595.876 48.9132Z",
  fill: "#C45513",
  stroke: "#C45513",
  strokeWidth: 0.5
});

var _ref229 = /*#__PURE__*/React.createElement("path", {
  d: "M595.554 46.648C594.637 46.9551 593.942 46.9717 593.942 46.9717C593.942 46.9717 593.62 45.0293 595.231 45.0293C597.165 45.0293 597.165 46.648 597.165 46.648C597.165 46.648 596.52 46.3243 595.554 46.648Z",
  fill: "white",
  stroke: "#C45513",
  strokeWidth: 0.4
});

var _ref230 = /*#__PURE__*/React.createElement("path", {
  d: "M599.097 46.3237C598.84 46.0647 597.809 46 597.164 46V46.6475H598.131C598.775 46.6475 599.42 46.6475 599.097 46.3237Z",
  fill: "white",
  stroke: "#C45513",
  strokeWidth: 0.3
});

var _ref231 = /*#__PURE__*/React.createElement("path", {
  d: "M604.576 53.7695C604.06 53.7695 603.717 53.9854 603.609 54.0933C603.609 54.3091 603.674 54.7408 603.932 54.7408C604.189 54.7408 605.113 54.3091 605.543 54.0933C605.435 53.9854 605.092 53.7695 604.576 53.7695Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref232 = /*#__PURE__*/React.createElement("path", {
  d: "M484.744 69.8077C484.809 69.8077 485.076 69.8077 485.622 69.8077C486.168 69.8077 486.37 69.6117 486.402 69.5137",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref233 = /*#__PURE__*/React.createElement("path", {
  d: "M339.744 63.474C340.42 68.7761 346.344 69.8439 349.79 70.2359C350.213 70.2359 351.604 70.0595 353.789 69.3539C357.301 68.2199 357.886 64.16 357.886 62.788C357.886 59.2601 355.545 58.2801 355.838 54.8502C355.938 53.6742 356.325 52.4002 355.838 49.5583C355.615 48.2591 353.887 45.6384 350.473 45.1484C345.693 44.4624 341.401 46.7164 342.279 52.4982C343.135 58.1304 339.256 59.6521 339.744 63.474Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref234 = /*#__PURE__*/React.createElement("path", {
  d: "M349.79 51.7138V77.1932H349.205L349.041 51.7357L349.501 49.6543L349.79 51.7138Z",
  fill: "white",
  stroke: "white"
});

var _ref235 = /*#__PURE__*/React.createElement("path", {
  d: "M349.889 56.0254C350.376 55.8948 351.488 55.5158 352.035 55.0455C352.581 54.5751 353.173 54.0001 353.4 53.7715",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref236 = /*#__PURE__*/React.createElement("path", {
  d: "M351.643 55.2412C351.578 54.9145 351.487 54.2024 351.643 53.9672C351.799 53.732 351.968 53.4119 352.033 53.2812",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref237 = /*#__PURE__*/React.createElement("path", {
  d: "M348.817 52.401C348.427 52.2704 347.549 51.9502 347.159 51.715C346.768 51.4798 346.086 50.8331 345.793 50.5391",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref238 = /*#__PURE__*/React.createElement("path", {
  d: "M347.547 51.9103C347.547 51.5837 347.508 50.8912 347.352 50.7344",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref239 = /*#__PURE__*/React.createElement("path", {
  d: "M349.889 63.9633C350.702 64.0613 352.425 64.1985 352.815 63.9633C353.205 63.7281 353.693 63.408 353.888 63.2773",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref240 = /*#__PURE__*/React.createElement("path", {
  d: "M351.838 63.9644C351.968 63.5725 352.267 62.7689 352.423 62.6905C352.579 62.6121 352.943 62.4618 353.106 62.3965",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref241 = /*#__PURE__*/React.createElement("path", {
  d: "M348.813 59.9456C348.163 59.8803 346.745 59.7104 346.277 59.5536C345.809 59.3968 344.651 58.5736 344.131 58.1816",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref242 = /*#__PURE__*/React.createElement("path", {
  d: "M346.084 59.358C346.051 59.0313 345.927 58.3192 345.693 58.084",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref243 = /*#__PURE__*/React.createElement("path", {
  d: "M347.448 59.8477C347.22 60.109 346.668 60.5728 346.277 60.7296",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref244 = /*#__PURE__*/React.createElement("path", {
  d: "M349.011 66.2183C348.296 66.1857 346.728 66.0811 345.792 65.9244C344.856 65.7676 343.776 65.0097 343.354 64.6504",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref245 = /*#__PURE__*/React.createElement("path", {
  d: "M347.06 66.0217C347.06 65.7277 346.962 65.1593 346.572 64.8457",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref246 = /*#__PURE__*/React.createElement("path", {
  d: "M342.963 65.9229C343.028 65.9229 343.295 65.9229 343.841 65.9229C344.387 65.9229 344.589 65.7269 344.621 65.6289",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref247 = /*#__PURE__*/React.createElement("path", {
  d: "M893.542 59.2766C892.283 69.1421 881.262 71.1289 874.849 71.8583C874.063 71.8583 871.473 71.5301 867.408 70.2172C860.874 68.1072 859.785 60.553 859.785 58.0002C859.785 51.4359 864.141 49.6125 863.596 43.2305C863.41 41.0424 862.689 38.672 863.596 33.3841C864.011 30.9666 867.226 26.0904 873.578 25.1787C882.472 23.9023 890.458 28.0962 888.824 38.8543C887.232 49.334 894.449 52.1652 893.542 59.2766Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref248 = /*#__PURE__*/React.createElement("path", {
  d: "M874.85 37.3965V84.8054H875.939L876.244 37.4373L875.387 33.5645L874.85 37.3965Z",
  fill: "white",
  stroke: "white"
});

var _ref249 = /*#__PURE__*/React.createElement("path", {
  d: "M874.666 45.4185C873.759 45.1753 871.69 44.4703 870.673 43.5951C869.657 42.7198 868.556 41.6501 868.132 41.2246",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref250 = /*#__PURE__*/React.createElement("path", {
  d: "M871.4 43.9593C871.521 43.3515 871.691 42.0265 871.4 41.5889C871.11 41.1513 870.795 40.5556 870.674 40.3125",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref251 = /*#__PURE__*/React.createElement("path", {
  d: "M876.663 38.6735C877.389 38.4304 879.022 37.8347 879.748 37.3971C880.474 36.9595 881.745 35.756 882.289 35.209",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref252 = /*#__PURE__*/React.createElement("path", {
  d: "M879.022 37.7604C879.022 37.1526 879.094 35.864 879.385 35.5723",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref253 = /*#__PURE__*/React.createElement("path", {
  d: "M874.666 60.1885C873.154 60.3708 869.947 60.6261 869.221 60.1885C868.495 59.7509 867.588 59.1552 867.225 58.9121",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref254 = /*#__PURE__*/React.createElement("path", {
  d: "M871.039 60.189C870.797 59.4596 870.241 57.9644 869.95 57.8185C869.66 57.6726 868.982 57.393 868.68 57.2715",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref255 = /*#__PURE__*/React.createElement("path", {
  d: "M876.665 52.7118C877.875 52.5903 880.513 52.2742 881.384 51.9825C882.255 51.6907 884.409 50.1591 885.377 49.4297",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref256 = /*#__PURE__*/React.createElement("path", {
  d: "M881.745 51.6185C881.805 51.0107 882.035 49.6857 882.471 49.248",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref257 = /*#__PURE__*/React.createElement("path", {
  d: "M879.205 52.5293C879.628 53.0155 880.657 53.8786 881.383 54.1704",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref258 = /*#__PURE__*/React.createElement("path", {
  d: "M876.298 64.3823C877.629 64.3215 880.545 64.127 882.287 63.8353C884.029 63.5435 886.038 62.1334 886.824 61.4648",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref259 = /*#__PURE__*/React.createElement("path", {
  d: "M879.93 64.0182C879.93 63.4712 880.112 62.4136 880.838 61.8301",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref260 = /*#__PURE__*/React.createElement("path", {
  d: "M887.553 63.8341C887.432 63.8341 886.936 63.8341 885.919 63.8341C884.903 63.8341 884.528 63.4695 884.467 63.2871",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref261 = /*#__PURE__*/React.createElement("path", {
  d: "M810.866 55.1977C811.809 62.5881 820.065 64.0764 824.869 64.6228C825.458 64.6228 827.398 64.3769 830.444 63.3935C835.338 61.8128 836.154 56.1539 836.154 54.2415C836.154 49.3241 832.891 47.9581 833.299 43.1773C833.439 41.5381 833.979 39.7624 833.299 35.8011C832.988 33.9901 830.58 30.3373 825.821 29.6543C819.159 28.6981 813.176 31.8399 814.4 39.899C815.593 47.7495 810.186 49.8704 810.866 55.1977Z",
  fill: "#121212",
  stroke: "#121212"
});

var _ref262 = /*#__PURE__*/React.createElement("path", {
  d: "M824.868 38.8062V74.321H824.053L823.824 38.8368L824.466 35.9355L824.868 38.8062Z",
  fill: "white",
  stroke: "white"
});

var _ref263 = /*#__PURE__*/React.createElement("path", {
  d: "M825.006 44.8175C825.686 44.6353 827.236 44.1072 827.997 43.4515C828.758 42.7959 829.583 41.9945 829.9 41.6758",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref264 = /*#__PURE__*/React.createElement("path", {
  d: "M827.454 43.7241C827.363 43.2688 827.237 42.2762 827.454 41.9484C827.672 41.6205 827.907 41.1743 827.998 40.9922",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref265 = /*#__PURE__*/React.createElement("path", {
  d: "M823.512 39.7633C822.968 39.5812 821.744 39.1349 821.2 38.8071C820.656 38.4793 819.705 37.5778 819.297 37.168",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref266 = /*#__PURE__*/React.createElement("path", {
  d: "M821.745 39.0786C821.745 38.6233 821.69 37.658 821.473 37.4395",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref267 = /*#__PURE__*/React.createElement("path", {
  d: "M825.006 55.88C826.139 56.0166 828.541 56.2078 829.085 55.88C829.628 55.5522 830.308 55.106 830.58 54.9238",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref268 = /*#__PURE__*/React.createElement("path", {
  d: "M827.723 55.8808C827.904 55.3345 828.321 54.2144 828.538 54.1051C828.756 53.9958 829.264 53.7864 829.49 53.6953",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref269 = /*#__PURE__*/React.createElement("path", {
  d: "M823.508 50.281C822.602 50.1899 820.626 49.9532 819.974 49.7346C819.321 49.516 817.708 48.3686 816.982 47.8223",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref270 = /*#__PURE__*/React.createElement("path", {
  d: "M819.704 49.4613C819.659 49.006 819.486 48.0134 819.16 47.6855",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref271 = /*#__PURE__*/React.createElement("path", {
  d: "M821.606 50.1445C821.289 50.5088 820.518 51.1553 819.975 51.3739",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref272 = /*#__PURE__*/React.createElement("path", {
  d: "M823.784 59.0215C822.787 58.9759 820.603 58.8302 819.297 58.6117C817.992 58.3931 816.488 57.3368 815.898 56.8359",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref273 = /*#__PURE__*/React.createElement("path", {
  d: "M821.063 58.7485C821.063 58.3387 820.927 57.5465 820.383 57.1094",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref274 = /*#__PURE__*/React.createElement("path", {
  d: "M815.352 58.6129C815.442 58.6129 815.814 58.6129 816.575 58.6129C817.337 58.6129 817.618 58.3397 817.663 58.2031",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref275 = /*#__PURE__*/React.createElement("path", {
  d: "M911.041 69.557C910.016 77.5935 901.037 79.212 895.813 79.8062C895.173 79.8062 893.063 79.5388 889.752 78.4693C884.429 76.7505 883.542 70.5967 883.542 68.5172C883.542 63.1698 887.09 61.6844 886.647 56.4855C886.495 54.7031 885.908 52.772 886.647 48.4644C886.985 46.4951 889.604 42.5229 894.778 41.7802C902.023 40.7404 908.529 44.1568 907.197 52.9206C905.901 61.4575 911.78 63.7639 911.041 69.557Z",
  fill: "#121212",
  stroke: "#121212"
});

var _ref276 = /*#__PURE__*/React.createElement("path", {
  d: "M895.813 51.733V90.3531H896.701L896.949 51.7663L896.251 48.6113L895.813 51.733Z",
  fill: "white",
  stroke: "white"
});

var _ref277 = /*#__PURE__*/React.createElement("path", {
  d: "M895.666 58.268C894.927 58.0699 893.241 57.4956 892.413 56.7826C891.586 56.0696 890.689 55.1982 890.344 54.8516",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref278 = /*#__PURE__*/React.createElement("path", {
  d: "M893.002 57.0802C893.101 56.585 893.239 55.5056 893.002 55.1491C892.766 54.7927 892.509 54.3074 892.411 54.1094",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref279 = /*#__PURE__*/React.createElement("path", {
  d: "M897.29 52.7715C897.881 52.5734 899.212 52.0882 899.803 51.7317C900.395 51.3752 901.43 50.3948 901.873 49.9492",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref280 = /*#__PURE__*/React.createElement("path", {
  d: "M899.212 52.0286C899.212 51.5334 899.271 50.4838 899.508 50.2461",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref281 = /*#__PURE__*/React.createElement("path", {
  d: "M895.666 70.2995C894.434 70.4481 891.822 70.656 891.231 70.2995C890.639 69.943 889.9 69.4578 889.604 69.2598",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref282 = /*#__PURE__*/React.createElement("path", {
  d: "M892.711 70.2985C892.514 69.7043 892.06 68.4863 891.824 68.3675C891.587 68.2487 891.035 68.0209 890.789 67.9219",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref283 = /*#__PURE__*/React.createElement("path", {
  d: "M897.292 64.2089C898.278 64.1098 900.426 63.8524 901.136 63.6147C901.846 63.377 903.6 62.1293 904.389 61.5352",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref284 = /*#__PURE__*/React.createElement("path", {
  d: "M901.43 63.3177C901.479 62.8226 901.667 61.7432 902.021 61.3867",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref285 = /*#__PURE__*/React.createElement("path", {
  d: "M899.363 64.0605C899.708 64.4567 900.545 65.1597 901.137 65.3974",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref286 = /*#__PURE__*/React.createElement("path", {
  d: "M896.993 73.7165C898.077 73.667 900.453 73.5085 901.872 73.2709C903.292 73.0332 904.928 71.8845 905.568 71.3398",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref287 = /*#__PURE__*/React.createElement("path", {
  d: "M899.952 73.4192C899.952 72.9736 900.1 72.112 900.691 71.6367",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref288 = /*#__PURE__*/React.createElement("path", {
  d: "M906.162 73.2698C906.064 73.2698 905.659 73.2698 904.831 73.2698C904.004 73.2698 903.698 72.9728 903.649 72.8242",
  stroke: "white",
  strokeLinecap: "round"
});

var _ref289 = /*#__PURE__*/React.createElement("path", {
  d: "M585.718 61.1289C587.56 58.4541 593.271 53.8087 601.373 56.6253C609.476 59.442 610.588 67.7334 610.132 71.5271",
  stroke: "#C45513"
});

var _ref290 = /*#__PURE__*/React.createElement("path", {
  d: "M610.217 70.1486L630.897 70.121L633.666 70.1173L633.649 56.7556L610.892 56.7861C611.008 57.4181 611.172 59.0098 610.897 60.3204C610.622 61.6311 609.314 62.6213 608.651 62.9958C608.795 63.2829 609.171 64.2019 609.606 65.4944C610.092 66.942 610.216 69.2866 610.217 70.1486Z",
  fill: "white",
  stroke: "#C45513"
});

var _ref291 = /*#__PURE__*/React.createElement("path", {
  d: "M594.387 50.8924C596.055 54.4179 595.874 55.0341 595.875 55.7129C595.875 55.7129 594.223 55.863 593.392 56.0338C592.561 56.2046 591.854 56.4407 591.854 56.4407C591.851 54.0798 591.919 50.5293 592.162 50.0016C592.325 49.6499 594.113 50.3137 594.387 50.8924Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref292 = /*#__PURE__*/React.createElement("path", {
  d: "M605.873 54.6896L610.294 48.914",
  stroke: "#C45513",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref293 = /*#__PURE__*/React.createElement("path", {
  d: "M607.338 51.7031L610.542 54.0264",
  stroke: "#C45513"
});

var _ref294 = /*#__PURE__*/React.createElement("path", {
  d: "M632.52 53.9978C633.351 54.7553 633.619 56.2088 633.648 56.8409L609.162 56.8737L611.233 52.8195L630.269 52.794C630.672 52.8797 631.688 53.2404 632.52 53.9978Z",
  fill: "white",
  stroke: "#C45513"
});

var _ref295 = /*#__PURE__*/React.createElement("rect", {
  x: 0.50065,
  y: 0.499331,
  width: 1.24985,
  height: 14.5171,
  transform: "matrix(0.999999 -0.00133684 0.00130016 0.999999 623.243 39.8737)",
  fill: "white",
  stroke: "#C45513"
});

var _ref296 = /*#__PURE__*/React.createElement("path", {
  d: "M622.891 50.0286L625.872 50.0246L625.889 63.7412C625.891 64.5642 625.224 65.2323 624.401 65.2334C623.578 65.2345 622.91 64.5682 622.909 63.7452L622.891 50.0286Z",
  fill: "#121212",
  stroke: "#C45513"
});

var _ref297 = /*#__PURE__*/React.createElement("path", {
  d: "M606.225 71.998L606.121 72.3735L606.461 72.5645L607.756 73.2924L605.738 76.8568L604.443 76.1289L604.103 75.9379L603.834 76.2203C603.168 76.9191 602.407 77.5124 601.565 77.9904L601.225 78.1836L601.33 78.5592L601.729 79.9858L597.771 81.085L597.372 79.6567L597.267 79.2824L596.877 79.2925C595.908 79.3175 594.949 79.2016 594.016 78.9468L593.639 78.844L593.447 79.1835L592.717 80.4732L589.137 78.4617L589.868 77.172L590.06 76.8326L589.777 76.5646C589.075 75.9008 588.48 75.143 588 74.3038L587.807 73.9663L587.431 74.0706L585.998 74.4687L584.895 70.5256L586.326 70.1279L586.703 70.0232L586.693 69.6332C586.668 68.6678 586.785 67.7122 587.04 66.7829L587.143 66.4074L586.804 66.2165L585.508 65.4886L587.527 61.924L588.822 62.6519L589.162 62.8428L589.431 62.5605C590.097 61.8619 590.858 61.2684 591.7 60.7903L592.04 60.5971L591.935 60.2215L591.536 58.795L595.494 57.6959L595.893 59.1242L595.998 59.4985L596.388 59.4885C597.357 59.4635 598.316 59.5795 599.249 59.8341L599.626 59.9369L599.818 59.5974L600.548 58.3077L604.127 60.3192L603.397 61.6089L603.205 61.9483L603.488 62.2163C604.189 62.8801 604.785 63.6379 605.265 64.4772L605.458 64.8146L605.833 64.7103L607.267 64.3123L608.37 68.2554L606.938 68.653L606.561 68.7577L606.572 69.1477C606.596 70.1133 606.48 71.0687 606.225 71.998ZM595.52 57.6887C595.52 57.6887 595.52 57.6887 595.519 57.6887L595.52 57.6887ZM607.293 64.3051C607.293 64.3051 607.293 64.3051 607.293 64.3051L607.293 64.3051L607.293 64.3051ZM608.378 68.2832C608.378 68.2831 608.378 68.283 608.378 68.2829L608.378 68.2832ZM608.398 68.2477C608.398 68.2477 608.398 68.2477 608.398 68.2477L608.398 68.2477Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref298 = /*#__PURE__*/React.createElement("path", {
  d: "M603.228 69.4685C603.233 73.1423 600.247 76.1276 596.555 76.1325C592.863 76.1374 589.87 73.1601 589.865 69.4864C589.86 65.8127 592.846 62.8274 596.538 62.8224C600.23 62.8175 603.223 65.7948 603.228 69.4685Z",
  fill: "white",
  stroke: "#C45513"
});

var _ref299 = /*#__PURE__*/React.createElement("path", {
  d: "M597.862 69.3882C597.863 70.1577 597.238 70.7855 596.461 70.7866C595.684 70.7876 595.056 70.1615 595.055 69.3919C595.054 68.6224 595.68 67.9946 596.457 67.9935C597.234 67.9925 597.861 68.6187 597.862 69.3882Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref300 = /*#__PURE__*/React.createElement("rect", {
  x: 0.209027,
  y: 0.208476,
  width: 5.44982,
  height: 0.417511,
  rx: 0.208756,
  transform: "matrix(0.999999 -0.00133683 0.00130017 0.999999 614.062 62.4319)",
  fill: "#C45513",
  stroke: "#C45513",
  strokeWidth: 0.417511
});

var _ref301 = /*#__PURE__*/React.createElement("path", {
  d: "M629.132 57.261L633.237 57.2556L633.252 69.3589L629.147 69.3643L629.132 57.261Z",
  fill: "white",
  stroke: "#C45513"
});

var _ref302 = /*#__PURE__*/React.createElement("rect", {
  x: 0.209024,
  y: 0.208473,
  width: 5.44976,
  height: 0.417505,
  transform: "matrix(0.999999 -0.00133683 0.00130017 0.999999 614.058 59.0921)",
  fill: "#C45513",
  stroke: "#C45513",
  strokeWidth: 0.417505
});

var _ref303 = /*#__PURE__*/React.createElement("rect", {
  x: 0.209027,
  y: 0.208476,
  width: 5.44982,
  height: 0.417511,
  transform: "matrix(0.999999 -0.00133683 0.00130017 0.999999 614.058 60.762)",
  fill: "#C45513",
  stroke: "#C45513",
  strokeWidth: 0.417511
});

var _ref304 = /*#__PURE__*/React.createElement("rect", {
  x: 0.215786,
  y: 0.215218,
  width: 3.03003,
  height: 0.431012,
  transform: "matrix(0.999999 -0.00133688 0.00130012 0.999999 630.363 58.6565)",
  fill: "#C45513",
  stroke: "#C45513",
  strokeWidth: 0.431012
});

var _ref305 = /*#__PURE__*/React.createElement("rect", {
  x: 0.215787,
  y: 0.215218,
  width: 3.03003,
  height: 0.431014,
  transform: "matrix(0.999999 -0.00133689 0.00130011 0.999999 630.365 60.553)",
  fill: "#C45513",
  stroke: "#C45513",
  strokeWidth: 0.431014
});

var _ref306 = /*#__PURE__*/React.createElement("rect", {
  x: 0.215785,
  y: 0.215217,
  width: 3.03003,
  height: 0.43101,
  transform: "matrix(0.999999 -0.00133688 0.00130012 0.999999 630.406 62.4104)",
  fill: "#C45513",
  stroke: "#C45513",
  strokeWidth: 0.43101
});

var _ref307 = /*#__PURE__*/React.createElement("path", {
  d: "M610.609 69.424C610.591 69.0425 610.561 68.5451 610.508 67.9758L630.741 67.9488L630.743 69.7071L610.621 69.734C610.618 69.6417 610.614 69.538 610.609 69.424Z",
  fill: "#121212",
  stroke: "#C45513"
});

var _ref308 = /*#__PURE__*/React.createElement("path", {
  d: "M640.267 74.2459C640.272 77.9196 637.286 80.9049 633.594 80.9098C629.902 80.9148 626.909 77.9375 626.904 74.2637C626.899 70.59 629.885 67.6047 633.577 67.5998C637.269 67.5948 640.263 70.5722 640.267 74.2459Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref309 = /*#__PURE__*/React.createElement("path", {
  d: "M637.498 74.2506C637.5 76.4008 635.752 78.1494 633.59 78.1523C631.427 78.1552 629.675 76.4112 629.672 74.261C629.669 72.1108 631.417 70.3622 633.58 70.3593C635.742 70.3564 637.495 72.1004 637.498 74.2506Z",
  fill: "white",
  stroke: "#C45513"
});

var _ref310 = /*#__PURE__*/React.createElement("path", {
  d: "M634.557 74.2532C634.558 74.7847 634.125 75.2193 633.587 75.22C633.049 75.2207 632.616 74.7873 632.615 74.2558C632.614 73.7244 633.047 73.2898 633.585 73.289C634.123 73.2883 634.556 73.7218 634.557 74.2532Z",
  fill: "#C45513",
  stroke: "#C45513"
});

var _ref311 = /*#__PURE__*/React.createElement("path", {
  d: "M590.449 57.0841L590.432 43.7773",
  stroke: "#C45513"
});

var _ref312 = /*#__PURE__*/React.createElement("path", {
  d: "M590.43 41.8467L588.278 44.2105L590.002 44.2082L605.728 44.1871L604.432 41.828L590.43 41.8467Z",
  fill: "#C45513"
});

var _ref313 = /*#__PURE__*/React.createElement("path", {
  d: "M590.019 57.3001L590.002 44.2082M588.278 44.2105L590.43 41.8467L604.432 41.828L605.728 44.1871L588.278 44.2105Z",
  stroke: "#C45513",
  strokeLinecap: "round"
});

var _ref314 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  d: "M623.266 36.2878C622.525 37.28 623.267 38.3052 623.699 38.9405C623.98 39.3541 624.824 39.753 625.2 39.2015C625.576 38.65 625.421 38.0768 624.827 37.424C624.233 36.7712 625.492 35.832 625.956 35.356C626.896 34.391 626.52 33.4259 625.392 32.7366C624.35 32.1002 625.535 31.8366 625.956 31.2201C626.52 30.393 625.956 28.5682 625.956 28.8765C625.956 29.7037 624.038 30.5381 623.699 31.358C623.266 32.4029 624.233 33.0504 624.827 33.5638C625.556 34.1936 624.233 34.9929 623.266 36.2878Z",
  fill: "#121212"
});

var _ref315 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M624.897 35.821C625.495 36.9057 624.621 37.8194 624.107 38.3892C623.772 38.7602 622.882 39.0395 622.584 38.4415C622.287 37.8434 622.518 37.297 623.196 36.7319C623.873 36.1668 622.754 35.0635 622.359 34.5283C621.559 33.443 622.063 32.5388 623.275 32.0111C624.394 31.5238 623.255 31.0998 622.922 30.4312C622.476 29.5343 623.284 27.8043 623.242 28.1097C623.129 28.929 624.915 30.0192 625.139 30.8781C625.425 31.9726 624.379 32.4811 623.721 32.908C622.914 33.4318 624.115 34.4053 624.897 35.821Z",
  fill: "#121212"
});

function SvgGrowerLandscape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 961,
    height: 92,
    viewBox: "0 0 961 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272, _ref273, _ref274, _ref275, _ref276, _ref277, _ref278, _ref279, _ref280, _ref281, _ref282, _ref283, _ref284, _ref285, _ref286, _ref287, _ref288, _ref289, _ref290, _ref291, _ref292, _ref293, _ref294, _ref295, _ref296, _ref297, _ref298, _ref299, _ref300, _ref301, _ref302, _ref303, _ref304, _ref305, _ref306, _ref307, _ref308, _ref309, _ref310, _ref311, _ref312, _ref313, _ref314, _ref315);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowerLandscape);
export default __webpack_public_path__ + "static/media/GrowerLandscape.5bd7ea84.svg";
export { ForwardRef as ReactComponent };